"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IVideoDeviceManagerImpl = void 0;
const NATIVE_RTC = __importStar(require("@iris/native-rtc"));
const util_1 = require("../util");
//@ts-ignore
class IVideoDeviceManagerImpl {
    constructor(engine) {
        this._engine = engine;
    }
    enumerateVideoDevices() {
        let deviceList = [];
        let process = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            try {
                deviceList = (_a = (yield this._engine.implHelper.enumerateDevices())) === null || _a === void 0 ? void 0 : _a.videoDevices;
            }
            catch (e) {
                util_1.AgoraConsole.log(e);
                return this._engine.returnResult(false);
            }
            return this._engine.returnResult(true, 0, JSON.stringify({ result: deviceList }));
        });
        return this._engine.execute(process);
    }
    setDevice_4ad5f6e(deviceIdUTF8) {
        let process = () => __awaiter(this, void 0, void 0, function* () {
            this._engine.globalState.videoDeviceId = deviceIdUTF8;
            for (let videoTrackPackage of this._engine.irisClientManager
                .localVideoTrackPackages) {
                if (videoTrackPackage.track) {
                    if (videoTrackPackage.type ==
                        NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_CAMERA_PRIMARY ||
                        videoTrackPackage.type ==
                            NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_CAMERA_SECONDARY ||
                        videoTrackPackage.type ==
                            NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_CAMERA_THIRD ||
                        videoTrackPackage.type ==
                            NATIVE_RTC.VIDEO_SOURCE_TYPE.VIDEO_SOURCE_CAMERA_FOURTH) {
                        yield this._engine.trackHelper.setDevice(videoTrackPackage.track, deviceIdUTF8);
                    }
                }
            }
            return this._engine.returnResult();
        });
        return this._engine.execute(process);
    }
    getDevice_73b9872() {
        let process = () => __awaiter(this, void 0, void 0, function* () {
            let list = [];
            let deviceId = '';
            if (this._engine.globalState.videoDeviceId) {
                deviceId = this._engine.globalState.videoDeviceId;
            }
            else {
                try {
                    list = yield this._engine.globalState.AgoraRTC.getCameras();
                }
                catch (e) {
                    return this._engine.returnResult(false);
                }
                if (list && list.length > 0) {
                    deviceId = list[0].deviceId;
                }
            }
            return this._engine.returnResult(true, 0, JSON.stringify({
                result: NATIVE_RTC.ERROR_CODE_TYPE.ERR_OK,
                deviceIdUTF8: deviceId,
            }));
        });
        return this._engine.execute(process);
    }
    release() {
        let process = () => __awaiter(this, void 0, void 0, function* () {
            let engine = this._engine;
            engine.globalState.videoDevices = new Array();
            return this._engine.returnResult();
        });
        return this._engine.execute(process);
    }
}
exports.IVideoDeviceManagerImpl = IVideoDeviceManagerImpl;
